module.exports = __webpack_public_path__ + "img/sp5.b39e0281.svg";